import { onSubmit } from '../../handlers';
import { setUcfirst } from '../../handlers/helpers';

const setLower = (value) => {
  return value.toLowerCase().trim();
};
const setUpper = (value) => {
  return value.toUpperCase().trim();
};
export const setUcwords = (value) => {
  return (' ' + value).replace(/ [\w]/g, a => a.toLocaleUpperCase()).trim();
};
const caseTypes = {
  'lowercase': setLower,
  'uppercase': setUpper,
  'ucwords': setUcwords,
  'ucfirst': setUcfirst,
};
const setCase = (qObj, value) => {
  if (typeof qObj.case !== 'undefined') {
    value = caseTypes[qObj.case](value);
  }
  return value;
};
export const transformRSInput = (e, jobSeekerData, index, qObj,  props) => {
  let value = e.target.value;
  value = setCase(qObj, value);
  transform(value, jobSeekerData, index, qObj,  props);
};
export const transformRSCurrency = (e, jobSeekerData, index, qObj, handlers, props) => {
  let value = e.target.value;
  let stripDecimal = value.indexOf('.') === -1 ? value.length : value.indexOf('.');
  value = value.substring(0, stripDecimal);
  value = value.replace(/\D/g, '');
  let intval = parseInt(value);
  if (isNaN(intval)) {
    value = '';
  } else {
    let round = 10 ** (value.length - 2);
    value = (Math.round(intval / round)) * round;
    value = value.toString();
    value = isNaN(value) ? 0 : value;
    value = '$' + value.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  }
  if (value.length === 10) {
    value = value.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
  transform(value, jobSeekerData, index, qObj, props);
};
export const transformRSPhone = (e, jobSeekerData, index, qObj, handlers, props) => {
  let value = e.target.value;
  value = value.replace(/\D/g, '');
  if (value.length === 10) {
    value = value.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
  transform(value, jobSeekerData, index, qObj, props);
};
const transform = (value, jobSeekerData, index, qObj,  props) => {
  //I wish I didn't have to do this.
  //the submit is triggering on every key stroke whether or not
  //there is a transformation
  /*
  const resumeIndex = props.stateProps.sectionData.resumeIndex;
  const sectionName = props.stateProps.sectionData.sectionName;
  props.stateProps.dataToSave.saved.resumes[resumeIndex][sectionName][index][qObj.qid] = value;*/
  jobSeekerData[index][qObj.qid] = value;
  onSubmit(props.formikProps, props.stateProps);
};